import { Permission } from '@cims-online/shared'
import { RestoreRowActionOptions } from 'components/CIMSTable/CIMSTableContext/types/actions/row'
import { Target } from '../../TargetsContext/types'
import { useTargetsContext } from '../../TargetsContext'
import { useRestoreAsphaltMixDesignTargetMutation } from 'schema'
import { DefaultMutationHookOptions } from 'utils/defaults'
import { simpleRestoreNotification } from 'hooks/notificationHandler'

export function useRestore(): RestoreRowActionOptions<Target> {
  const { refetch } = useTargetsContext()
  const [restore] = useRestoreAsphaltMixDesignTargetMutation({
    ...DefaultMutationHookOptions,
    onCompleted: ({
      restoreLIMSAsphaltMixDesignTarget: {
        target: { name },
      },
    }) => simpleRestoreNotification(name),
  })
  return {
    permission: Permission.RemoveRestoreLIMSAsphaltMixDesignTarget,
    metadata: ({ deleted, deletedDate, deletedUser }) => ({
      removed: deleted,
      removedBy: deletedUser,
      removedDate: deletedDate,
    }),
    default: 'active',
    onRestore: async ({ id }) => {
      await restore({ variables: { id } })
      refetch()
    },
  }
}
